<div class="flex items-center gap-sm cursor-pointer relative">
  <button
    type="button"
    class="bg-transparent cursor-pointer flex"
    (click)="toggleMenu($event)">
    <ng-content>
      <div class="flex items-center gap-sm">
        @if (dropdownLabel()) {
          <p
            class="text-primary-500 flex justify-center items-center text-sm py-sm font-medium">
            {{ dropdownLabel() }}
          </p>
        }
        <lib-chevron-down-icon
          [iconClass]="
            'size-5 text-primary-500 ' + (isMenuOpen() ? 'rotate-180' : '')
          " />
      </div>
    </ng-content>
  </button>

  @if (isMenuOpen()) {
    <div
      #menuContainer
      class="flex flex-col absolute bg-white shadow-xl rounded-lg items-center gap-sm py-lg max-h-[21rem] min-h-20 start-1/2 end-auto overflow-x-hidden overflow-y-auto z-[2] translate-x-[calc(-50%+var(--dropdown-shift,0px))]"
      [class]="
        (isListPositionTop() ? 'bottom-10' : 'top-10') +
        ' ' +
        dropdownClass() +
        ` w-[${menuWidth()}]`
      "
      [style.--dropdown-shift.px]="horizontalShift()"
      [style.height.px]="menuHeight() ? menuHeight() : 'auto'"
      libClickOutSide
      (clickOutside)="isMenuOpen.set(false)">
      @if (listTitle() || hasCloseButton()) {
        <div class="px-lg py-md w-full flex justify-between items-center">
          @if (listTitle()) {
            <p class="text-md font-semibold">{{ listTitle() }}</p>
          }
          @if (hasCloseButton()) {
            <button type="button" (click)="isMenuOpen.set(false)">
              <lib-close-icon
                [iconClass]="
                  'size-6 text-neutral-900 hover:text-neutral-700'
                " />
            </button>
          }
        </div>
      }

      @for (item of menuItems(); track $index; let index = $index) {
        <ng-container
          [ngTemplateOutlet]="menuTemplateRef()"
          [ngTemplateOutletContext]="{ $implicit: item, i: index }">
        </ng-container>
      }
    </div>
  }
</div>
